import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    inputFileUpload: {
      display: 'none',
    },
    fileButton: {
      paddingLeft: theme.spacing(),
    },
    reminderButton: {
      marginLeft: theme.spacing(),
      marginBottom: theme.spacing(-4),
    },
  };
};
